import { i18n } from '../i18n';
import { LOCIZE_NS } from './common';

export const NICKNAME_MIN_LENGTH = 3;
export const NICKNAME_MAX_LENGTH = 15;

export const validationsNickname = {
  validate: {
    minLength: (value: string | number) =>
      String(value).length >= NICKNAME_MIN_LENGTH ||
      i18n.t(`${LOCIZE_NS.COMMON}:Validations.nickname.minLength`, {
        length: NICKNAME_MIN_LENGTH,
      }),
    maxLength: (value: string | number) =>
      String(value).length <= NICKNAME_MAX_LENGTH ||
      i18n.t(`${LOCIZE_NS.COMMON}:Validations.nickname.maxLength`, {
        length: NICKNAME_MAX_LENGTH,
      }),
  },
} as const;

export const PASSWORD_MIN_LENGTH = 8;

const PASSWORD_RULES: Array<{
  test: (pwd: string) => boolean;
  errorKey: string;
  requirementKey: string;
}> = [
  {
    test: pwd => pwd.length >= PASSWORD_MIN_LENGTH,
    errorKey: `${LOCIZE_NS.AUTH}:SignupForm.Form.password.error.length`,
    requirementKey: `${LOCIZE_NS.AUTH}:SignupForm.PasswordRequirement.length`,
  },
  {
    test: pwd => /[A-Z]/.test(pwd),
    errorKey: `${LOCIZE_NS.AUTH}:SignupForm.Form.password.error.uppercase`,
    requirementKey: `${LOCIZE_NS.AUTH}:SignupForm.PasswordRequirement.uppercase`,
  },
  {
    test: pwd => /[a-z]/.test(pwd),
    errorKey: `${LOCIZE_NS.AUTH}:SignupForm.Form.password.error.lowercase`,
    requirementKey: `${LOCIZE_NS.AUTH}:SignupForm.PasswordRequirement.lowercase`,
  },
  {
    test: pwd => /[0-9]/.test(pwd),
    errorKey: `${LOCIZE_NS.AUTH}:SignupForm.Form.password.error.number`,
    requirementKey: `${LOCIZE_NS.AUTH}:SignupForm.PasswordRequirement.number`,
  },
  {
    test: pwd => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd),
    errorKey: `${LOCIZE_NS.AUTH}:SignupForm.Form.password.error.special`,
    requirementKey: `${LOCIZE_NS.AUTH}:SignupForm.PasswordRequirement.special`,
  },
];

export const PASSWORD_REQUIREMENTS = PASSWORD_RULES.map(({ test, requirementKey }) => ({
  test,
  requirementKey,
}));

export const validationsRequired = {
  required: `${LOCIZE_NS.COMMON}:Common.required`,
} as const;

export const validatePassword = (value: string | number): string | boolean => {
  const password = String(value);
  if (!password) return 'SignupForm.Form.password.error.required';
  const failed = PASSWORD_RULES.find(rule => !rule.test(password));
  return failed ? failed.errorKey : true;
};

export const validationsPassword = {
  ...validationsRequired,
  validate: validatePassword,
} as const;

export const createConfirmPasswordValidator =
  (field: string, errorKey: string) =>
  (value: string | number, formValues?: unknown): string | boolean =>
    String(value) === String((formValues as Record<string, unknown>)?.[field] ?? '') || errorKey;
